
/**
 * Format a price value to USD currency string
 */
export const formatPrice = (price: number | undefined): string => {
    if (price === undefined || price === null) return ''
    return `${price.toFixed(2)}`
  }